import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-edit-warn-message',
    templateUrl: './edit-warn-message.component.html',
})
export class EditWarnMessageComponent {
    public readonly displayedMessage: InputSignal<string> = input('editMode.currentEditNotIncludedInSearch');
}
